<template>
  <button v-if="machineName" class="fit20-font-light chart-button" translate="no" :style="backgroundColor" v-on:click="$emit('toggle-line', index)">
    {{ machineName }}
  </button>
</template>

<script>
export default {
  name: 'ChartButton',
  props: ['machineName', 'backgroundColor', 'index'],
  created(){
    // console.log(this.backgroundColor);
  }
};
</script>

<style>
.chart-button {
  width: calc(50% - 6px);
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 17px;
  margin: 0 3px 3px 3px;
  font-size: 19px;
  font-weight: bold;
}
</style>
